/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  ExportDoorReportsV2MutationRequest,
  ExportDoorReportsV2MutationResponse,
  ExportDoorReportsV2400,
  ExportDoorReportsV2500,
} from '../types/ExportDoorReportsV2'

function getExportDoorReportsV2Url() {
  const res = {
    method: 'POST',
    url: `/api/v1/reports/doors/export/v2/` as const,
  }
  return res
}

/**
 * @description Start an async door reports export.
 * @summary Start an async door CRM reports export
 * {@link /api/v1/reports/doors/export/v2/}
 */
export async function exportDoorReportsV2(
  data: ExportDoorReportsV2MutationRequest,
  config: Partial<RequestConfig<ExportDoorReportsV2MutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    ExportDoorReportsV2MutationResponse,
    ResponseErrorConfig<ExportDoorReportsV2400 | ExportDoorReportsV2500>,
    ExportDoorReportsV2MutationRequest
  >({
    method: 'POST',
    url: getExportDoorReportsV2Url().url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
